import React from 'react';
import { Typography, Slider, TextField } from '@mui/material';

const marks = [
    {
        value: 0,
        label: '0%',
    },
    {
        value: 100,
        label: '100%',
    },
];

const PlanAllocationOfAnnuitiesSlider = ({ value, handleSliderChange, handleAnnuityTextBoxChange }) => (
    <div>
        <Typography variant={"h6"}  id="discrete-slider-custom" gutterBottom>
            Maximum Allocation of Annuities
        </Typography>
        <Typography id="discrete-slider-custom" gutterBottom>
            Please specify maximum allocation of annuities in portfolio
        </Typography>
        <Slider
            value={value}
            onChange={handleSliderChange}
            aria-labelledby="discrete-slider-custom"
            step={5}
            valueLabelDisplay="auto"
            marks={marks}
        />
        <div className={"plan-automation-annuities-textbox-container"}>
            <TextField
                id="filled-number"
                type="number"
                InputLabelProps={{
                    shrink: true,
                }}
                value={value}
                onChange={handleAnnuityTextBoxChange}
            />
        </div>

    </div>
);

export default PlanAllocationOfAnnuitiesSlider;
